/**
 * @class
 * @description Dash js loader class. It receives dash instance to listen, intercept and modify the requests if needed.
 * @exports LoaderDash
 */
export default class LoaderDash {
    /**
     * Constructs dash loader object.
     * @param {Object} player dash player instance.
     */
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    constructor(player) {
        player.extend('XHRLoader', () => {
            return {
                load: this.load,
                abort: this.abort
            };
        });
    }
    /**
     * Load method called by dash when requests a url load.
     * Decides what to do checking the type of the request (manifest or segment).
     * It requests manifests normally, and for segments it uses the loader object.
     * @param {Object} httpRequest String with the url for the manifest request, or request object for video segments.
     * @public
     */
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    load(httpRequest) {
        if (httpRequest.url.indexOf('.mpd') >= 0) {
            // Manifest
            LoaderDash._engine.setManifestResource(httpRequest.url);
        }
        const headers = {};
        if (httpRequest.request.range) {
            headers['Range'] = `bytes=${httpRequest.request.range}`;
        }
        LoaderDash._engine.request(new URL(httpRequest.url), true, [
            (req) => {
                httpRequest.response = {
                    responseType: 'arraybuffer',
                    response: req.data,
                    responseURL: httpRequest.url,
                    onload: httpRequest.onload,
                    onloadend: httpRequest.onend,
                    onerror: httpRequest.onerror,
                    onprogress: httpRequest.progress,
                    onabort: httpRequest.onabort,
                    ontimeout: httpRequest.ontimeout,
                    timeout: httpRequest.timeout,
                    status: 206,
                    readyState: 4,
                    statusText: 'Partial Content'
                };
                httpRequest.onload();
                httpRequest.onend();
            }
        ], headers);
    }
    /**
     * Abort method called by dash when aborting a request.
     * @param {XMLHttpRequest} request The request aborted.
     * @public
     */
    abort(request) {
        const x = request.response;
        if (x) {
            x.onloadend = x.onerror = x.onprogress = undefined;
            x.abort();
        }
    }
}
